import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const ProfitInformationPDF = ( { deal } ) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Profit Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text style={baseStyles.flex}>
                        Vehicle
                    </Text>
                    <Text>{pdfData.vehicle_profit.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>
                        Trade
                    </Text>
                    <Text>{pdfData.trade_profit.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text>
                        Total Profit
                    </Text>
                    <Text>{pdfData.total_profit.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}